import { render, staticRenderFns } from "./SlTpModal.vue?vue&type=template&id=3775b4ae&scoped=true"
import script from "./SlTpModal.vue?vue&type=script&lang=js"
export * from "./SlTpModal.vue?vue&type=script&lang=js"
import style0 from "./SlTpModal.vue?vue&type=style&index=0&id=3775b4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775b4ae",
  null
  
)

export default component.exports